import React, { useState, useRef, useEffect } from "react";
import styles from "./TimeInputWrapper.module.css";
import Input from "../common/Input";
import TimeWheelPicker from ".";

interface TimeInputWrapperProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  initial?: string;
}

const TimeInputWrapper: React.FC<TimeInputWrapperProps> = ({
  value,
  onChange,
  disabled,
  initial,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleTimeSelect = (hour: number, minute: number) => {
    const time = `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
    onChange(time);
    setIsOpen(false);
  };

  const handleClickOutside = (e: MouseEvent) => {
    if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={styles.wrapper} ref={wrapperRef}>
      <Input
        type="text"
        readOnly
        value={value}
        onClick={() => !disabled && setIsOpen(true)}
        placeholder="ЧЧ:ММ"
        disabled={disabled}
      />
      {isOpen && <TimeWheelPicker initial={initial ?? value} onSelect={handleTimeSelect} />}
    </div>
  );
};

export default TimeInputWrapper;
